import React from "react";
import { Link } from "react-router-dom";

const EMBROIDERY_DETAIL = "https://customer-assets.emergentagent.com/job_atelier-tall/artifacts/55qqbuh3_ChatGPT%20Image%20May%2019%2C%202026%2C%2001_08_42%20PM.png";
const ATELIER_IMG_1 = "https://customer-assets.emergentagent.com/job_atelier-tall/artifacts/rog5ibph_ChatGPT%20Image%20May%2019%2C%202026%2C%2001_15_48%20PM.png";
const ATELIER_IMG_2 = "https://customer-assets.emergentagent.com/job_atelier-tall/artifacts/y2qa8rm3_ChatGPT%20Image%20May%2019%2C%202026%2C%2001_15_40%20PM.png";

export default function About() {
  return (
    <div className="bg-[#f0e9e1]" data-testid="about-page">
      <section className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 pt-12 sm:pt-16 lg:pt-24 pb-16 sm:pb-20 grid grid-cols-12 gap-6 lg:gap-12">
        <div className="col-span-12 lg:col-span-7 fade-up">
          <div className="micro-label text-[#1a1814]/60 mb-5 sm:mb-6">The Atelier</div>
          <h1 className="font-display text-[44px] sm:text-7xl lg:text-8xl text-[#1a1814] leading-[0.95]">
            We started this house because trousers kept ending<em className="italic"> too soon.</em>
          </h1>
        </div>
        <div className="col-span-12 lg:col-span-5 lg:pt-32 fade-up fade-up-2">
          <p className="text-[#1a1814]/75 leading-relaxed text-base sm:text-lg">
            The Identity Atelier is a slow studio dedicated to women 5'9" and above. Every pattern is drafted on tall fit models, every fabric is hand-selected for weight and recovery, and every order is finished in a small atelier in Portugal.
          </p>
          <p className="text-[#1a1814]/75 leading-relaxed mt-5 sm:mt-6">
            Our work is unhurried — two collections a year, in small runs, made to last.
          </p>
        </div>
      </section>

      {/* Embroidery signature feature */}
      <section className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 pb-16 sm:pb-24 grid grid-cols-12 gap-6 lg:gap-12 items-center" data-testid="about-embroidery">
        <div className="col-span-12 lg:col-span-7 fade-up">
          <div className="aspect-[4/3] overflow-hidden bg-[#efe6db]">
            <img src={EMBROIDERY_DETAIL} alt="The TIA monogram — embroidered tonal across the collection" className="w-full h-full object-cover" style={{ objectPosition: "center 20%" }} />
          </div>
        </div>
        <div className="col-span-12 lg:col-span-5 fade-up fade-up-2">
          <div className="micro-label text-[#1a1814]/60 mb-4">A quiet signature</div>
          <h2 className="font-display text-4xl lg:text-5xl">Embroidered. Never printed.</h2>
          <p className="text-[#1a1814]/75 leading-relaxed mt-6">
            Our TIA monogram is hand-guided through a vintage Tajima at our finishing studio, in a thread tonal to the cloth. You'll find it on every heritage piece — the Quarter-Zip, the Jogger, the Rugby Tops, the Tee — quietly placed, like all good identity should be.
          </p>
          <Link to="/shop" className="inline-block mt-8 micro-label underline underline-offset-8 decoration-[0.5px] hover:opacity-60" data-testid="about-embroidery-cta">
            See the embroidered pieces →
          </Link>
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 pb-24 grid grid-cols-12 gap-6 lg:gap-12">
        <div className="col-span-12 lg:col-span-6 fade-up">
          <div className="aspect-[4/5] bg-[#efe6db] overflow-hidden">
            <img src={ATELIER_IMG_1} alt="Atelier mocha rugby & sculpt legging" className="w-full h-full object-cover" style={{ objectPosition: "center 30%" }} />
          </div>
        </div>
        <div className="col-span-12 lg:col-span-5 lg:col-start-8 self-center fade-up fade-up-2">
          <div className="micro-label text-[#1a1814]/60 mb-4">Our materials</div>
          <h2 className="font-display text-4xl lg:text-5xl">Considered fabric. Considered hours.</h2>
          <p className="text-[#1a1814]/75 leading-relaxed mt-6">
            Heavyweight organic cotton fleeces from a single mill in northern Portugal. Recycled performance knits from a family workshop near Porto. Heavyweight pima cotton woven for our heritage stripes. We don't make seasonal noise — we build a foundation.
          </p>
        </div>
      </section>

      <section className="max-w-[1440px] mx-auto px-6 lg:px-12 pb-24 grid grid-cols-12 gap-6 lg:gap-12">
        <div className="col-span-12 lg:col-span-5 self-center order-2 lg:order-1 fade-up">
          <div className="micro-label text-[#1a1814]/60 mb-4">For the tall</div>
          <h2 className="font-display text-4xl lg:text-5xl">Inseams to 34". Sleeves +3cm. Hems +6cm.</h2>
          <p className="text-[#1a1814]/75 leading-relaxed mt-6">
            We don't add length as an afterthought. Patterns are graded a second time, with our tall fit team, so a size M-Tall is M-Tall everywhere — across the bust, across the hip, across the inseam.
          </p>
          <div className="flex flex-wrap gap-3 mt-10">
            <Link to="/shop" className="bg-[#1a1814] text-[#f0e9e1] px-10 py-4 micro-label hover:bg-[#1a1814]/85" data-testid="about-shop-cta">
              Explore the Collection
            </Link>
            <Link to="/fit-quiz" className="border border-[#1a1814] text-[#1a1814] px-10 py-4 micro-label hover:bg-[#1a1814]/5" data-testid="about-quiz-cta">
              Find your fit
            </Link>
          </div>
        </div>
        <div className="col-span-12 lg:col-span-6 lg:col-start-7 order-1 lg:order-2 fade-up fade-up-2">
          <div className="aspect-[4/5] bg-[#efe6db] overflow-hidden">
            <img src={ATELIER_IMG_2} alt="The Identity Atelier — Spring Lookbook" className="w-full h-full object-cover" style={{ objectPosition: "center 30%" }} />
          </div>
        </div>
      </section>
    </div>
  );
}
